<!-- 电子围栏报警 -->
<template>
  <div>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
    >
      <template slot="alarmState" slot-scope="{ row }">
        <el-tag :type="row.alarmState === 'ALARMING' ? 'danger' : 'success'" size="small" effect="light">
          {{ row.alarmStateName || "-" }}
        </el-tag>
      </template>
      <template slot="menu" slot-scope="{ row }">
        <el-button type="text" size="small" icon="el-icon-view" @click="handleView(row)">
          详情
        </el-button>
      </template>
    </avue-crud>

    <el-dialog
      title="电子围栏报警详情"
      :visible.sync="detailVisible"
      width="720px"
      append-to-body
    >
      <el-descriptions :column="2" border size="small">
        <el-descriptions-item label="报警状态">
          <el-tag :type="detail.alarmState === 'ALARMING' ? 'danger' : 'success'" size="small" effect="light">
            {{ detail.alarmStateName || "-" }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="围栏名称">{{ detail.fenceName || "-" }}</el-descriptions-item>
        <el-descriptions-item label="tagId">{{ detail.tagId || "-" }}</el-descriptions-item>
        <el-descriptions-item label="作业人员">{{ detail.employeeName || "-" }}</el-descriptions-item>
        <el-descriptions-item label="所属班组">{{ detail.teamName || "-" }}</el-descriptions-item>
        <el-descriptions-item label="工单号">{{ detail.workOrderId || "-" }}</el-descriptions-item>
        <el-descriptions-item label="进入时间">{{ detail.enterTime || "-" }}</el-descriptions-item>
        <el-descriptions-item label="离开时间">{{ detail.leaveTime || "-" }}</el-descriptions-item>
        <el-descriptions-item label="停留">{{ detail.stayDurationText || "-" }}</el-descriptions-item>
        <el-descriptions-item label="报警说明">{{ detail.alarmMessage || "-" }}</el-descriptions-item>
      </el-descriptions>
      <span slot="footer">
        <el-button type="primary" @click="detailVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList } from "./api";
import { getSearchTimeConfig } from "@/basic-common/util/common";

export default {
  name: "electronic-fence-alarm",
  mixins: [crudMixins],
  data() {
    return {
      form: {},
      detail: {},
      detailVisible: false,
      apiConfig: { getList },
      option: {
        ...this.$store.state.publicOption,
        rowKey: "id",
        stripe: true,
        menu: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        viewBtn: false,
        column: [
          {
            label: "报警状态",
            prop: "alarmState",
            type: "select",
            search: true,
            slot: true,
            width: 110,
            dicData: [
              { label: "报警中", value: "ALARMING" },
              { label: "已解除", value: "RESOLVED" },
            ],
            props: {
              label: "label",
              value: "value",
            },
          },
          {
            label: "围栏名称",
            prop: "fenceName",
            search: true,
            minWidth: 140,
            overHidden: true,
          },
          {
            label: "tagId",
            prop: "tagId",
            search: true,
            minWidth: 120,
            overHidden: true,
          },
          {
            label: "作业人员",
            prop: "employeeName",
            search: true,
            minWidth: 110,
            overHidden: true,
          },
          {
            label: "所属班组",
            prop: "teamName",
            minWidth: 120,
            overHidden: true,
          },
          {
            label: "进入时间",
            prop: "enterTime",
            minWidth: 160,
          },
          {
            label: "离开时间",
            prop: "leaveTime",
            minWidth: 160,
          },
          {
            label: "停留",
            prop: "stayDurationText",
            minWidth: 110,
          },
          {
            label: "工单号",
            prop: "workOrderId",
            minWidth: 150,
            overHidden: true,
          },
          {
            ...getSearchTimeConfig("报警时间", { type: "datetimerange" }),
            paramsKey: ["startTime", "endTime"],
          },
        ],
      },
    };
  },
  methods: {
    handleView(row) {
      this.detail = { ...row };
      this.detailVisible = true;
    },
  },
};
</script>

<style scoped lang="scss"></style>
